export interface CognitoUser {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  type: number;
  image?: string;
  provider?: string;
  fullName: string;
}

export enum Provider {
  FACEBOOK = "Facebook",
  APPLE = "SignInWithApple",
  TM = "TM",
}

// models.ts or types.d.ts
type OAuthScope =
  | "phone"
  | "email"
  | "openid"
  | "profile"
  | "aws.cognito.signin.user.admin";

export interface AuthConfig {
  userPoolId: string;
  userPoolWebClientId: string;
  identityPoolId: string;
  oauth?: {
    domain: string;
    region: string;
    responseType: "code" | "token";
    redirectSignIn: [string];
    redirectSignOut: [string];
    scopes: OAuthScope[];
  };
}

interface APIEndpoint {
  name: string;
  endpoint: string;
}
export interface APIConfig {
  endpoints: APIEndpoint[];
}

interface S3Config {
  bucket: string;
  region: string;
}
export interface StorageConfig {
  AWSS3: S3Config;
}

export interface SignUpProperties {
  username: string;
  password: string;
  attributes: {
    preferred_username: string;
    email: string;
    family_name: string;
    name: string;
  };
}

export const CreatorType = {
  local: 0,
  facebook: 1,
  twitter: 2,
  tm: 3,
};

// @aws-amplify/auth, but not exported
export interface AuthWebAuthnCredential {
  credentialId: string | undefined;
  friendlyCredentialName: string | undefined;
  relyingPartyId: string | undefined;
  authenticatorAttachment?: string;
  authenticatorTransports: string[] | undefined;
  createdAt: Date | undefined;
}
